import { ref } from '@nuxtjs/composition-api';
import CatalogFilterHeader from '~/domains/catalog/components/CatalogFilterHeader.vue';


export default {
  __name: 'CatalogLayout',
  props: {
  enableSwitchFilters: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const isFiltersOpen = ref(true);
const isFiltersOpenMobile = ref(false);

const toggleFilters = () => {
  isFiltersOpen.value = !isFiltersOpen.value;
};
const toggleMobileFilters = () => {
  isFiltersOpenMobile.value = !isFiltersOpenMobile.value;
};

return { __sfc: true,isFiltersOpen, isFiltersOpenMobile, toggleFilters, toggleMobileFilters, CatalogFilterHeader }
}

}